export default {
    entityKey: 'applicationAccounts',
    titles: {
        singular: 'Application Account',
        plural: 'Application Accounts'
    }
}